// @react/hooks/useTenantTenant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { tenantTenantStore } from '@core/stores';

/**
 * React hook for Tenant operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTenantTenant } from '@react/hooks';
 *
 * const TenantList = observer(() => {
 *   const store = useTenantTenant();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTenantTenant() {
  return tenantTenantStore;
}
